import './module/sw-cms/elements/jga-revocation-button';
import './module/sw-cms/blocks/jga-revocation-button';
import './module/sw-order/view/sw-order-detail-revocation';
import './override/sw-order-detail-details';
import './component/jga-revocation-consent-list';
import './component/jga-revocation-link-hint';
import './component/jga-revocation-blocked-message';
import './component/jga-revocation-lookup-fields';
import './component/jga-revocation-period-start';

import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';

Shopware.Locale.extend('de-DE', deDE);
Shopware.Locale.extend('en-GB', enGB);
